export const FETCH_INVOICES = 'invoice::fetch_invoices';
export const FETCH_INVOICES_SUCCESS = 'invoice::fetch_invoices_success';
export const FETCH_INVOICES_ERROR = 'invoice::fetch_invoices_error';
export const TOGGLE_INVOICE = 'invoice::toggle_invoice';
export const TOGGLE_ALL_INVOICES = 'invoice::toggle_all_invoices';
export const CHANGE_PAYMENT_AMOUNT = 'invoice::change_payment_amount';
export const CHANGE_ADHOC_PAYMENT = 'invoice::change_adhoc_payment';
export const RESET_PAYMENT_AMOUNT = 'invoice::reset_payment_amount';
export const PAYMENT_TYPE = 'invoice::payment_type';
export const TOTAL_INVOICE_AMOUNT = 'invoice:total_invoice_amount';


// WEBPACK FOOTER //
// ./src/action-types/invoice.js